import React, { useState, useEffect, useContext, useRef } from 'react';

import UploadPDF from '../../components/inputs/UploadPDF'
import ButtonNext from '../../components/button/ButtonWhite'
import moment from "moment"
import { ReactComponent as NEXT } from '../../assets/IconsColurs/IconsGeneral/chevronRight.svg';
import { getHashKey } from '../../functions/createSignImages';
import axios from "axios"
import { AuthContext } from '../../context/AuthContext';
import ColorsMain from '../../colors/ColorsMain';
import { useNavigate } from "react-router-dom";
import ModalAlert from '../../components/modal/ModalAlert'

import { GLOBAL_LANGUAGE } from "../../language/language";
import { UtilContext } from "../../context/UtilContext";

const Rejected = () => {
    const navigate = useNavigate();

    const [isReady, setIsReady] = useState(false);
    const [loading, setLoading] = useState(false);
    const [LoadingLayouts, setLoadingLayouts] = useState(false)
    const [documents, setDocuments] = useState([]);
    const [documentsFinal, setDocumentsFinal] = useState(null);

    const [DocumentsUpload, setDocumentsUpload] = useState([]);

    const [errorMesagge, setErrorMesagge] = useState("");
    const [ModalActive, setModalActive] = useState(false);


    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;

    // Llama a forceUpdate() después de actualizar DocumentsUpload



    const { getAuthenticatedHeaders, logout, } = useContext(AuthContext);
    const onClick = async () => {
        // Validación 1: Verificar que todos los archivos estén cargados
        if (DocumentsUpload.length !== documents.length) {
            setErrorMesagge(t.rejected.error_validation_document);
            return;
        }

        try {
            // Inicializamos DocumentsFinal vacío
            const results = [];

            // Procesamos cada documento de manera secuencial
            for (const doc of DocumentsUpload) {
                console.log("codsods", doc);
                const response = await uploadFile(doc.name, doc.file);

                // Verificar que la respuesta tenga la URL esperada
                if (response !== t.rejected.file_too_large && response !== t.rejected.error_document_upload) {
                    if (doc.shareholder) {

                        results.push({
                            document_id: doc.id,
                            code_name: doc.name,
                            url: response,
                            is_shareholder: doc.shareholder,
                            shareholder_id: doc.shareholder_id
                        });
                    } else {
                        results.push({
                            document_id: doc.id,
                            code_name: doc.name,
                            url: response,
                            is_shareholder: doc.shareholder
                        });
                    }


                    console.log(`Archivo ${doc.name} subido correctamente.`);
                } else {
                    setErrorMesagge(t.rejected.error_loading_document);
                    console.warn(`No se recibió una URL válida para ${doc.name}`);
                    throw new Error(`Error al subir el archivo ${doc.name}`);
                }
            }

            // Actualizar el estado con los documentos subidos
            setDocumentsFinal(results);

            console.log("Todos los archivos se han subido y procesado:", results);
        } catch (error) {
            console.error("Error al subir los archivos:", error);
            setErrorMesagge(t.rejected.error_loading_document);
        }
    };

    console.log("setDocumentsFinal", documentsFinal);

    const listaDocumentos = async () => {
        const response = await axios.post(`/api/documents_rejects`, { headers: await getAuthenticatedHeaders() })
        if (response.data.data.code_transaction === "IncorrectDocumentStatus") {
            navigate("/");

        }
        else {

            setDocuments(response.data.data)

        }
    }
    console.log("documents_rejects_upload");


    const uploadFile = async (name, archivo,) => {


        setLoading(true)
        let file = archivo;

        const originalFileName = file?.name; // Por ejemplo: "Documento sin título.pdf"

        const formato = originalFileName.split('.').pop(); // Obtiene "pdf"
        console.log(formato);


        let newFileName = `${name}/${moment().valueOf()}.${formato}`;

        const headers = {
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY_DEV,
        };







        // Generar la firma
        const sign = getHashKey('documents'); // asegúrate de que 'documents' sea el valor correcto
        let formData = new FormData();
        formData.append("file", file);
        formData.append("sign", sign);
        formData.append("file_type", "documents");
        formData.append("file_name", newFileName);


        const header = await getAuthenticatedHeaders()
        const extendedHeaders = {
            ...header, // Los encabezados que ya tienes
            'Content-Type': 'multipart/form-data', // Otro ejemplo de encabezado adicional
        };



        const jsonString = JSON.stringify(extendedHeaders);
        formData.append("header", jsonString);


        try {
            const response = await axios.post(`/upload-image`, formData,)
            console.log("response", response.data.data.result);

            if (response.data.data.result === "OK") {
                console.log("response", response);


                return (response.data.data.url)

            }
        } catch (error) {
            setLoading(false)
            if (error.status === 413) {
                return t.rejected.file_too_large
            } else {
                return t.rejected.error_document_upload
            }
        }
        setLoading(false)
    };
    const SubidaDocumentos = async () => {
        const response = await axios.post(`/api/documents_rejects_upload`, { headers: await getAuthenticatedHeaders(), data: documentsFinal })
        console.log("response", response.data?.data?.code_transactio);
        if (response.data?.data?.code_transaction === "ok") {
            setModalActive(true)
        }


    }
    useEffect(() => {
        listaDocumentos()


    }, [])



    useEffect(() => {
        if (
            !LoadingLayouts

        ) {
            setIsReady(true)
        }
    }, [
        LoadingLayouts
    ]);
    useEffect(() => {
        if (documentsFinal !== null) {
            SubidaDocumentos()
        }
    }, [documentsFinal])
    if (!isReady) {
        return <div className="flex md:flex-row flex-wrap p-4 w-full" >
            <div className="w-full" >
                <div style={{ height: "50vh", }} className='flex items-center justify-center'>
                    <div className="h-20  w-20 flex">
                        <div className="spinner-border-white-full animate-spin w-14 h-14 border-4 border-white border-t-transparent rounded-full"></div>

                    </div>
                </div>
            </div>
        </div>

    }
    const Redirect = () => {
        navigate("/");
    }

    const handleSetDocument = (id, file) => {
        console.log("doc", id, file);

        setDocumentsUpload((prev) => ([...prev, {

            file: file,
            id: id.id,
            name: id.type_document.code,
            shareholder: id.is_shareholder,
            shareholder_id: id.is_shareholder ? id.shareholder.id : null,

        }]
        )
        );
    };


    return (


        <div className='w-full h-screen overflow-y-auto flex px-80' style={{ background: ColorsMain.bgMain }}>
            {ModalActive && <ModalAlert title={t.rejected.title_modal} description={t.rejected.subtitle_modal} onClick={() => Redirect()} labelButtonWhite={t.rejected.button_label} />}

            <div className="w-full h-fit pb-16"  >
                <div className='gap-2 flex flex-col ' >
                    <p className=" text-2xl mt-8 " style={{ fontFamily: "brico" }} >
                        {t.rejected.title}
                    </p>
                </div>

                {documents.map((doc) => (


                    <div key={doc.id} className="mt-12">

                        <p className="mb-1 text-[#B7B7B9]">{doc.type_document.name}</p>
                        {doc.shareholder && <p className="font-bold text-lg text-white  leading-relaxed">
                            <span className='text-[#B7B7B9]'>{t.rejected.label_shareholder} </span> {doc.shareholder.name}
                        </p>}
                        <p className="text-[#A0A0A5] text-sm tracking-wide uppercase mt-3">

                        </p>
                        <p className="font-bold text-lg text-white  leading-relaxed">
                            <span className='text-[#B7B7B9]'> {t.rejected.subtitle}</span> {doc.note}
                        </p>


                        <UploadPDF
                            setUploadedFile={(e) => handleSetDocument(doc, e)}
                            showDelect={false}
                            uploadedFile={DocumentsUpload.find((item) => item.id === doc.id)?.file} // Pasar el archivo actual o null si no existe
                        />

                        <div className='w-full bg-[#5E5E63] h-[1px] my-4 '></div>
                    </div>
                ))}



                {errorMesagge && (
                    <div className="w-full flex flex-col mt-1">
                        <p className="text-[#FF928B] text-[16px] ">{t.rejected.error_validation_final}</p>
                    </div>
                )}

                <div className='flex justify-between w-full' >

                    <ButtonNext label={'Enviar'} Icon={NEXT} onClick={onClick} loading={loading} />

                </div>
            </div >

        </div>



    );
};

export default Rejected;

